<template>
  <div class="container">
    <div class="recommend-skill" @click="jumpRecPage">
      <p class="rec-btn">{{$t('upgrade_page_views_dashboard_recommend_index_1514')}}</p>
      <div class="rec-skill-right">
        <p>{{$t('upgrade_page_views_dashboard_recommend_index_1515')}}</p>
        <img src="~@/assets/images/white-right-arrow.png" alt="">
      </div>
    </div>
    <div class="title">{{$t('upgrade_page_views_dashboard_recommend_index_1516')}}</div>
    <div class="title-two">{{$t('upgrade_page_views_dashboard_recommend_index_1517')}}</div>
    <div class="service-type">
      <span class="strong">{{$t('upgrade_page_views_dashboard_recommend_index_1518')}}</span>
      <fps-icon class="open-detail" type="warning-inline" @click.native="openRulesDialog('skill')" />
      <!-- <span class="change-skill" @click="openAddServeDig" v-if="confrimSkillId">更換技能</span> -->
    </div>
    <p class="service-rule">{{$t('upgrade_page_views_dashboard_recommend_index_1519')}}</p>
    <template v-if="skillList.length">
      <p v-if="!confrimSkillId" class="add-serve" @click="openAddServeDig">{{$t('upgrade_page_views_dashboard_recommend_index_1520')}}</p>
      <div class="selected-skill" @click="openAddServeDig" v-else>
        <p>{{confrimSkillName}} {{confrimDiscountName}}</p>
        <div class="edit-skill-icon"></div>
      </div>
    </template>
    <div class="service-rule" v-else>{{$t('upgrade_page_views_dashboard_recommend_index_1521')}}</div>
    <!-- <div class="selected-skill-mobile" v-if="confrimSkillId" @click="openAddServeDig">
      <p>{{confrimSkillName}} {{confrimDiscountName}}</p>
      <div class="selected-mobile-right">
        <p>修改</p><fps-icon class="arrow-icon" type="arrow-right" />
      </div>
    </div> -->
    <div class="auto-send">
      <div class="auto-send-header">
        <div class="auto-reply">
          <div class="auto-reply-title">
            <p>{{$t('upgrade_page_views_dashboard_recommend_index_1522')}}</p>
          </div>
          <div class="auto-reply-text">{{$t('upgrade_page_views_dashboard_recommend_index_1523')}}</div>
        </div>
        <span class="auto-switch">
          <p class="switch-title">{{ autoSend ? $t('upgrade_page_views_dashboard_recommend_index_1524') : $t('upgrade_page_views_dashboard_recommend_index_1525')}}</p>
          <fps-switch
            :value="autoSend"
            :disabled="!autoSend && !confrimSkillId"
            @change="handleSwitch"
          >
          </fps-switch>
        </span>
      </div>
      <el-input
        type="textarea"
        v-model="autoSendMsg"
        maxlength="100"
        show-word-limit
        :rows="6"
        class="auto-send-msg"
        :disabled="!autoSend"
      ></el-input>
      <span class="auto-switch auto-switch-mobile">
        <p class="switch-title">{{ autoSend ? $t('upgrade_page_views_dashboard_recommend_index_1526') : $t('upgrade_page_views_dashboard_recommend_index_1527')}}</p>
        <fps-switch
          :value="autoSend"
          :disabled="!autoSend && !confrimSkillId"
          @change="handleSwitch"
          >
        </fps-switch>
      </span>
    </div>
    <div
      class="submit"
      @click="submit"
    >{{$t('upgrade_page_views_dashboard_recommend_index_1528')}}</div>
    <SlidDialog
      class="add-serve-dialog"
      :model="addServeDialog"
      @close="clearDialog"
      :title="confrimSkillId ? $t('upgrade_page_views_dashboard_recommend_index_1529') : $t('upgrade_page_layout_nav_51')"
    >
      <div class="slid-content" slot="slid-content">
        <p class="select-text" v-if="!isChangeCount">{{$t('upgrade_page_views_dashboard_recommend_index_1530')}}</p>
        <el-select
          v-if="!isChangeCount"
          v-model="checkedSkillId"
          :placeholder="$t('upgrade_page_views_dashboard_recommend_index_1531')"
          class="skill-drop custom-select"
          popper-class="skill-select-options"
          @change="handleCheckedSkillId"
        >
          <el-option
            class="skill-option"
            v-for="item in skillList"
            :key="item.id"
            :label="item.gameName"
            :value="item.id">
          </el-option>
        </el-select>
        <p class="select-text">{{$t('upgrade_page_views_dashboard_recommend_index_1532')}}</p>
        <el-select
          v-model="checkedDiscount"
          :placeholder="$t('upgrade_page_views_dashboard_recommend_index_1533')"
          class="skill-drop"
          popper-class="skill-select-options"
        >
          <el-option
            v-for="item in discountList"
            :key="item.num"
            class="skill-option"
            :label="item.name"
            :value="item.num">
          </el-option>
        </el-select>
        <span class="dialog-footer">
          <p class="close-skill" @click="delCheckedSkill">{{confrimSkillId ? $t('upgrade_page_views_dashboard_recommend_index_1534') : ''}}</p>
          <button class="button-yellow" :class="checkedSkillId && checkedDiscount ? '' : 'submitDisabled'" @click="confrimCheckedSkill(1)">{{$t('components_order_order_card_525')}}</button>
          <p class="close-skill-mobile" v-if="confrimSkillId" @click="delCheckedSkill">{{$t('upgrade_page_views_dashboard_recommend_index_1534')}}</p>
        </span>
      </div>
    </SlidDialog>
    <SlidDialog
      class="rules-dialog"
      :model="rulesDialog"
      :title="rulesType === 'skill' ? $t('upgrade_page_views_dashboard_recommend_index_1535') : $t('upgrade_page_views_dashboard_recommend_index_1536')"
      @close="clearBottomDialog"
    >
      <div
        slot="slid-content"
        class="rules-slid-content"
      >      
        <p 
          v-for="item in rulesList"
          :key="item"
        >
          {{item}}
        </p>
      </div>
    </SlidDialog>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import SlidDialog from './slid-dialog'
import { mapGetters } from 'vuex'
const skillList21b = [1,3,5,6,47,39,36,125]
export default {
  name: 'RecommentSelf',
  components: {
    SlidDialog,
  },
  data() {
    return {
      skillList: [],
      newskillList25: [],
      newskillList21: [],
      discountList: [
        {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1537'),num: 0.2 },
        {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1538'),num: 0.5 },
        {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1539'),num: 21 }
      ],
      rulesType: 'skill',
      checkedDiscount: 0.5,
      confrimDiscount: '',
      initDiscount: '',
      addServeDialog: false,
      checkedSkillId: '',
      confrimSkillId: '',
      redBagFreeFlags: {},
      rulesVisableTop: false,
      rulesVisableBottom: false,
      activeNames: ['0'],
      autoSendMsg:'',
      autoSend: false,
      initSkillId: '',
      initAutoSend: false,
      initAutoSendMsg: '',
      confrimSkillName: '',
      checkedSkill: {
        gameName: '',
        price: ''
      },
      confrimDiscountName: '',
      isChangeCount: false,
      rulesDialog: false,
      replyRules:[
        i18n.t('upgrade_page_views_dashboard_recommend_index_1540'),
        i18n.t('upgrade_page_views_dashboard_recommend_index_1541')
      ],
      skillRules:[
        i18n.t('upgrade_page_views_dashboard_recommend_index_1542'),
        i18n.t('upgrade_page_views_dashboard_recommend_index_1543'),
        i18n.t('upgrade_page_views_dashboard_recommend_index_1544'),
        i18n.t('upgrade_page_views_dashboard_recommend_index_1545')
      ],
      rulesList: [],
    }
  },
  computed:{
    ...mapGetters(['userInfo'])
  },
  created() {
    if(this.userInfo.userKind === 'Normal') {
      this.$router.push({
        name: 'homepage'
      })
    }
    this.getSkillMsg()
    this.getSendConfig()
  },
  watch:{
    userInfo(newVal) {
      if(newVal.userKind === 'Normal') {
        this.$router.push({
          name: 'homepage'
        })
      } else {
        this.getSkillMsg()
        this.getSendConfig()
      }
    },
    confrimSkillId(newVal) {
      if(newVal) {
        this.skillList.forEach(e => {
          if(e.id === newVal){
            this.confrimSkillName = e.gameName
          }
        });
      } else {
        this.confrimSkillName = ''
      }
    },
    confrimDiscount(newVal) {
      if(newVal) {
        this.discountList.forEach(e => {
          if(e.num === newVal){
            this.confrimDiscountName = e.name
          }
        });
      } else {
        this.confrimDiscountName = ''
      }
    },
  },
  beforeRouteLeave(to,from,next) {
    if(this.initAutoSendMsg !== this.autoSendMsg || this.initAutoSend !== this.autoSend) {
      this.$confirm({
        title: i18n.t('upgrade_page_views_dashboard_recommend_index_1546'),
        confirmButtonText: i18n.t('upgrade_page_views_dashboard_recommend_index_1547'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
      }).then(()=>{
        this.submit()
      })
    } else {
      next()
    }
  },
  methods: {
    handleSwitch() {
      this.autoSend = !this.autoSend
    },
    // 技能切換
    handleCheckedSkillId(skillId) {
      if (!skillId) return
      if (this.userInfo.playerScore >= 1300) {
        const newValue = this.skillList.filter((value) => {
          return value.id == skillId
        })
        const skillIs21b = skillList21b.indexOf(newValue[0].gameId)
        if (skillIs21b !==-1) {
          this.discountList = [
            {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1537'),num: 0.2 },
            {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1538'),num: 0.5 },
            {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1539'),num: 21 }
          ]
        } else {
          this.discountList = [
            {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1537'),num: 0.2 },
            {name:i18n.t('upgrade_page_views_dashboard_recommend_index_1538'),num: 0.5 },
          ]
        }
      }
    },
    getDiscountList() {
      // 获取自推广21币白名单
      this.$http.post('/player/skill/certification/selfSpread/whitelist', {})
        .then(({ data }) => {
          if (data) {
            const hansWhiteDiscount = data.indexOf(this.userInfo.uuid)
            if (hansWhiteDiscount !== -1) {
              this.discountList = [this.discountList[this.discountList.length - 1]]
              this.newskillList21 = this.skillList.filter((value) => {
                return skillList21b.indexOf(value.gameId) !== -1
              })
              this.skillList = [...this.newskillList21]
              this.confrimSkillName = this.newskillList21[0].gameName
              this.confrimSkillId = this.newskillList21[0].id
            }else {
              this.newskillList25 = this.skillList.filter((value) => {
                return value.countTransactions >= 10
              })
              if(this.userInfo.playerScore<1300) {
                this.skillList = [...this.newskillList25]
                this.discountList.splice(this.discountList.length - 1, 1)
              } else {
                this.newskillList21 = this.skillList.filter((value) => {
                  return skillList21b.indexOf(value.gameId) !== -1
                })
              }
            }
          }
        })
    },
    openRulesDialog(index){
      this.rulesList = index === 'reply' ? this.replyRules : this.skillRules
      this.rulesType = index
      this.rulesDialog = true
    },
    clearDialog() {
      this.isChangeCount = false
      this.rulesList = []
      this.addServeDialog = false
    },
    clearBottomDialog() {
      this.rulesDialog = false
    },
    changeDiscount() {
      this.isChangeCount = true
      this.addServeDialog = true
    },
    jumpRecPage() {
      this.$router.push({
        name: 'RecRule'
      })
    },
    getSendConfig() {
      // 获取自動發送消息配置
      this.$http.get('/im/user/config', { code: 11 }).then(({data})=>{
        this.autoSend = data.open
        this.initAutoSend = data.open
        this.autoSendMsg = data.content
        this.initAutoSendMsg = data.content
      })
    },
    rulesVisableTopHandler () {
      this.rulesVisableTop = !this.rulesVisableTop
    },
    rulesVisableBottomHandler () {
      this.rulesVisableBottom = !this.rulesVisableBottom
    },
    confrimCheckedSkill(index) {
      if ((this.checkedSkillId && !this.checkedDiscount) || (!this.checkedSkillId && this.checkedDiscount)) {
        return
      }
      if(index && !this.checkedSkillId && !this.checkedDiscount) {
        return
      }
      this.addServeDialog = false
      if (this.initSkillId !== this.checkedSkillId || this.initDiscount !== this.checkedDiscount) {
        const saveParam = this.checkedDiscount===21
        this.$http.post('/player/skill/certification/selfSpread', {
          skillId: this.checkedSkillId,
          selfSpreadDiscount: saveParam ? null : this.checkedDiscount,
          selfSpreadPrice: saveParam ? this.checkedDiscount : null
        }).then(() => {
          this.$message.success(i18n.t('components_order_order_card_564'))
          this.initSkillId = this.checkedSkillId
          this.initDiscount = this.checkedDiscount
          this.confrimSkillId = this.checkedSkillId
          this.confrimDiscount = this.checkedDiscount
          this.autoSend = this.confrimSkillId ? true : false
        }).catch(({code, msg})=>{
          if(code === 446) {
            this.$message.error(i18n.t('upgrade_page_views_dashboard_recommend_index_1548'))
            this.checkedSkillId = this.confrimSkillId
          } else if(code === 9000) {
            this.$message.error(msg)
          } else {
            this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1289'))
          }
        })
      }
    },
    delCheckedSkill() {
      this.addServeDialog = false
      this.$confirm({
        title: i18n.t('upgrade_page_views_dashboard_recommend_index_1549'),
        distinguishCancelAndClose: true,
        // customClass: 'del-checked-skill',
        confirmButtonText: i18n.t('upgrade_page_layout_header_45'),
        cancelButtonText: i18n.t('upgrade_page_views_dashboard_recommend_index_1550'),
      }).catch((action)=>{
        if (action === "cancel") {
          this.checkedSkillId = ''
          this.confrimSkillId = ''
          this.checkedDiscount = ''
          this.confrimCheckedSkill()
        }
      })
    },
    openAddServeDig() {
      this.isChangeCount = false
      this.checkedSkillId = this.confrimSkillId
      this.checkedDiscount = this.confrimDiscount
      this.addServeDialog = true
    },
    getSkillMsg() {
      this.$http.get('/player/skill/certification/skilllist').then(({data}) => {
        data.Success.forEach((skill, index, arr) => {
          if(skill.status === "Success") {
            this.skillList.push(skill)
            if(skill.redBagFreeFlag === 1) {
              this.checkedSkillId = skill.id
              this.confrimSkillId = skill.id 
              this.checkedSkill = skill
              this.checkedDiscount = skill.selfSpreadDiscount
              this.confrimDiscount = skill.selfSpreadDiscount
              this.initSkillId = skill.id
            }
          }
          if (arr.length > 0 && index === arr.length - 1) {
            setTimeout(() => {
              this.getDiscountList()
            }, 100)
          }
        });
      }).catch(() => {
        this.$message.error(i18n.t('upgrade_page_views_user_set_account_789'))
      })
    },
    submit() {
      if(this.autoSendMsg.length === 0 && this.autoSend) {
        this.$message.error(i18n.t('upgrade_page_views_dashboard_recommend_index_1551'))
        return
      }
      // 保存自動發送消息配置
      this.$http.post('/im/user/config/save', {
        code: 11,
        open: this.autoSend,
        content: this.autoSendMsg
      }).then(()=>{
        this.initAutoSend = this.autoSend
        this.initAutoSendMsg = this.autoSendMsg
        this.$message({
          type: 'success',
          message: i18n.t('components_order_order_card_564')
        })
      }).catch(() => {
        this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1289'))
      })
    }
  }
}
</script>
<style lang="scss">
.skill-option {
  text-align: left;
  height: 44px;
  line-height: 44px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 44px;
  color: #333333;
}
.container {
  .el-collapse {
    border-bottom: none;
  }
}
.add-serve-dialog {
    border-radius: 8px;
    width: 411px;
    top: 100px;
    padding: 45px 30px 0px 30px;
    height: fit-content;
    input {
      border-radius: 8px;
      border: 1px solid #999999;
    }
    .select-text {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 18px;
      color: #333333;
      margin: 0 0 20px 0;
    }
    .skill-drop {
      width: 100%;
      margin-bottom: 45px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      border-top: 1px solid #ECECEC;
      height: 90px;
      .submitDisabled {
        opacity: 0.5;
        cursor: not-allowed
      }
      p {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #333333;
        cursor: pointer;
      }
      button {
        width: 100px;
        cursor: pointer;
        height: 40px;
      }
      .close-skill-mobile {
        display: none;
      }
    }
}
.rules-dialog {
  border-radius: 15px;
  top: 100px;
  height: fit-content;
  .rules-slid-content {
    padding: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    .slid-title {
      box-shadow: 0px 5px 7.5px rgba(0, 0, 0, 0.1);
      border-radius: 15px 15px 0px 0px;
    }
    p {
      margin-bottom: 20px;
    }
  }
}
.skill-select-options {
  z-index: 3000 !important;
  .el-select-dropdown__item {
    &.selected {
      font-weight: normal;
      &::after {
        content: '';
        display: block;
        float: right;
        width: 12px;
        height: 12px;
        background: url('~@/assets/image/icons/success.png') no-repeat;
        background-size: 100%;
        margin-top: 14px;
      }
    }
  }
}
.notices {
  .el-icon-arrow-right {
    display: none;
  }
  // .el-switch {
  //   width: 51px;
  //   .el-switch__core {
  //     height: 31px;
  //     width: 51px;
  //     border-radius: 50px;
  //     &::after {
  //       width: 26px;
  //       height: 26px;
  //     }
  //   }
  // }
  
  .el-textarea {
    font-size: 16px;
    border: 1px solid #999999 !important;

  }
  .rules-text-bottom, .rules-text {
    .el-collapse-item__wrap, .el-collapse-item__header{
      border-bottom: none;
    }
  }
}
.auto-send {
  .auto-send-msg {
    width: 900px;
    mix-blend-mode: normal;
    opacity: 0.5;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    line-height: 30px;
    textarea {
      &:focus {
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2) !important;
      }
    }
  }
}
@media screen and (max-width: 599px){
  // .add-serve-dialog {
  //   .el-dialog {
  //     width: 100vw;
  //     position: fixed;
  //     bottom: 0px;
  //     box-shadow: 0px 5.00376px 7.50564px rgba(0, 0, 0, 0.1);
  //     border-radius: 20px 20px 0px 0px;
  //     margin: 0;
  //     padding-bottom: 50px;
  //     .el-dialog__header {
  //       border-radius: 20px 20px 0px 0px;
  //     }
  //   }
  // }
  .del-checked-skill {
    width: 90vw;
    top: 200px;
    border-radius: 14px;
    padding-bottom: 20px;
    .el-message-box__headerbtn {
      display: none;
    }
    .el-message-box__title {
      text-align: center;
      line-height: 25px;
    }
    .el-message-box__btns {
      display: flex;
      justify-content: center;
      button {
        border-radius: 22px;
        width: 111px;
        height: 44px;
      }

    }
  }
  .add-serve-dialog {
    height: 100vh;
    border-radius: 0;
    top: 0;
    .slid-title {
      border-bottom: none !important;
      p {
        display: none;
      }
    } 
    .slid-content {
      .select-text {
        margin:60px 0 30px 0;
      }
      input {
        // margin-bottom: 70px;
        background: #FFFFFF;
        box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        border: none;
        height: 54px;
      }
    }
    .dialog-footer {
      border: none;
      flex-direction: column;
      .el-button--primary {
        width: 100%;
        border-radius: 30px;
        height: 50px;
        flex-shrink: 0;
        margin-bottom: 140px;
      }
      .close-skill {
        display: none;
      }
      .close-skill-mobile {
        display: block;
        color: #333333;
        cursor: pointer;
        padding-bottom: env(safe-area-inset-bottom)
      }
    }
    
  }
  .skill-select-options {
    font-size: 16px;
    display: none;
  }
  .rules-dialog {
    border-radius: 15px 15px 0 0;
    bottom: 0px;
    top: unset;
  }
  .auto-send {
    .auto-send-msg {
      width: 90vw;
      mix-blend-mode: normal;
      opacity: 0.5;
      // border: 1px solid #999999 !important;
      box-sizing: border-box;
      border-radius: 4px;
      font-size: 16px;
      line-height: 30px;
      color: #333333;
      textarea {
        &:focus {
          // border: 1px solid #999999 !important;
          box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2) !important;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.button-yellow{
  width: 100px;
  cursor: pointer;
  height: 40px;
  padding: 12px 20px;
  border-radius: 4px;
  @include button-yellow;
}
.add-serve-dialog {
  .slid-content {
    padding: 45px 30px 0 30px;
  }
}
.skill-mobile-dialog, .discount-mobile-dialog {
  display: none;
}
.container {
  background: url('~@/assets/images/recommedself.png') no-repeat right 20px / 407px;
  box-sizing: border-box;
  color: #333;
  padding-bottom: 80px;
  padding-top: 30px;
  position: relative;
  .recommend-skill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    background: rgba(32, 33, 24, 0.5);
    position: absolute;
    width: 100%;
    top: -40px;
    cursor: pointer;
    .rec-btn {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 22px;
      text-align: center;
      color: #333333;
      width: 60px;
      height: 22px;
      background: $color-yellow;
      border-radius: 22px;
      margin-left: 18px;
    }
    .rec-skill-right {
      display: flex;
      margin-right: 18px;
      align-items: center;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 32px;
        color: #FFFFFF;
        margin-right: 5px;
      }
      img {
        width: 24px;
        height: 24px;
        position: relative;
        bottom: 1px;
      }
    }
  }
  .title {
    font-weight: 500;
    font-size: 22px;
    height: 31px;
    line-height: 31px;
    padding-left: 40px;
    margin-bottom:20px;
  }
  .title-two {
    width: 435px;
    padding-left: 40px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #999999;
  }

  .service-type {
    margin: 60px 0 0px 0;
    padding-left: 40px;
    font-size: 0;
    display: flex;
    align-items: center;
    .strong {
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      margin-right: 5px;
    }
    span {
      display: inline-block;
      font-size: 14px;
      line-height: 20px;
      vertical-align: middle;
    }
    .open-detail {
      font-size: 18px;
      transform: scaleY(-1);
      cursor: pointer;
      color: $color-gray-3;
    }
    .change-skill {
      font-weight: 500;
      font-size: 12px;
      line-height: 25px;
      color: #0075FF;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .service-rule {
    font-style: normal;
    font-weight: normal;
    padding-left: 40px;
    font-size: 14px;
    line-height: 20px;
    margin: 10px 0 20px 0;
    color: #999999;
  }
  .add-serve {
    padding-left: 40px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: $color-yellow;
    cursor: pointer;
  }
  .selected-skill {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 25px;
    width: fit-content;
    color: #FFFFFF;
    margin-left: 40px;
    height: 28px;
    padding: 0 8px;
    text-align: center;
    background: rgba(62, 69, 87, 0.9);
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: #767E93;
    }
    .edit-skill-icon {
      width: 9px;
      height: 9px;
      margin-left:10px;
      cursor: pointer;
      background: url('~@/assets/image/fps-icon/edit-icon.png') center center no-repeat;
      background-size: 100% 100%;
    }
  }
  .selected-skill-mobile {
    display: none;
  }
  .services-container {
    display: flex;
    width: 480px;
    flex-wrap: wrap;
    font-size: 0;
  }
  .one-game {
    margin: 20px 30px 0 0;
  }
  .services {
    .box {
      width: 15px;
      height: 15px;
      background: #FFFFFF;
      border: 1px solid #ABABB3;
      box-sizing: border-box;
      box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-right: 8px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .services .game-name {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    line-height: 20px;
  }
  .entertainment {
    margin-top: 30px
  }
  .services-title {
    font-size: 0;
    margin-bottom: 5px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      vertical-align: middle;
      font-weight: 500;
      font-size: 16px;
      line-height: 32px;
    }
  }
  .notices-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    img {
      height: 24px;
      width: 24px;
    }
    .up {
      transition: all 0.5s;
    }
    .down {
      transform:rotate(-180deg);
      transition: all 0.5s;
    }
  }
  .auto-send {
    margin-top: 10px;
    padding: 0 40px;
    .auto-send-header {
      display: flex;
      justify-content: space-between;
      height: 104px;
      align-items: center;
      .auto-reply {
        .auto-reply-title {
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: #333333;
          display: flex;
          align-items: center;
          margin: 41px 0 10px 0;
        }
        .auto-reply-text {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          margin-bottom: 20px;
        }
      }
      span {
        display: flex;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
      .auto-send-title {
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
      }
      .switch-title {
        color: #333333;
        margin-right: 10px;
        width: 30px;
        height: 26px;
        line-height: 26px;
      }
    }
    .auto-switch-mobile {
      display: none;
    }
    
  }
  .notices {
    margin-top: 60px;
    border-top: none;
    padding: 0 40px;
    .el-icon-arrow-right {
      display: none !important;
    }
    .show {
      transition: all 0.5s ease;
      transform:translateY(-150px);
    }
    .hide {
      transition: all 0.2s ease;
    }
    .notice {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 10px;
      color: #999999;
    }
  }
  .submit {
    cursor: pointer;
    width: 180px;
    height: 46px;
    background: $color-yellow;
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    color: $color-gray-1;
    line-height: 46px;
    text-align: center;
    margin: 30px 0 0 40px;
  }
}

@media screen and (max-width: 599px){
  .container {
    background: url('~@/assets/images/recommedself.png') no-repeat right 50px / 0px;
    background-size: 51.2vw 39.3vw;
    margin: 0 0 100px 0;
    padding-top: 0;
    .recommend-skill {
      position: relative;
      top: 0;
    }
    .title {
      padding: 0 18px;
      margin-top: 30px;
      height: 120px;
      line-height: 100px;
    } 
    .title-two {
      padding:0 18px;
      width: 100%;
    }
    .service-type {
      padding-left: 18px;
      display: flex;
      span:last-child {
        font-size: 14px;
        line-height: 20px;
        color: #999999;
      }
    }
    .service-rule {
      padding: 0 18px;
    }
    .auto-send {
      padding: 0 18px;
    }
    .add-serve {
      width: 90vw;
      margin: 0 auto;
      padding: 0;
      text-align: center;
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      height: 54px;
      line-height: 54px;
    }
    .notices {
      padding: 0 !important;
      width: 90vw;
      margin: 30px auto 0;
      .auto-send-header {
        span:first-child {
          display: flex;
          flex-direction: column;
        }
        .auto-switch {
          display: none !important;
        }
      }
      .auto-send-msg {
        width: 90vw;
        margin: 0 auto;
      }
      .auto-switch-mobile {
        display: flex;
        justify-content: space-between;
        height: 70px;
        align-items: center;
      }
    }
    .selected-skill {
      display: none;
    }
    .selected-skill-mobile {
      width: 90vw;
      height: 54px;
      line-height: 54px;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      padding: 0 18px;
      align-items: center;
      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      color: #333333;
      cursor: pointer;
      .selected-mobile-right {
        display: flex;
        align-items: center;
        p {
          font-size: 12px;
          color: #999999;
        }
        // img {
        //   width: 18px;
        //   height: 18px;
        //   margin-left: 5px;
        // }
      }
    }
    .submit {
      left: 18px;
      width: 90vw;
      bottom: -50px;
    }
    .services-container {
      width: 90vw;
    }
    .skill-mobile-dialog {
      display: unset;
      box-shadow: 0px 5px 7.5px rgba(0, 0, 0, 0.1);
      border-radius: 15px 15px 0px 0px;
      padding-bottom: 60px;
      .skill-slid-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 58px;
        width: 90vw;
        margin: 0 auto;
        line-height: 58px;
        border-bottom: 1px solid  #E0E0E0;
        .skill-item-msg {
          display: flex;
          align-items: center;
          img {
            width: 36px;
            height: 36px;
            margin-right: 12px;
            background: #F6F6F6;
            border-radius: 4.5px;
            filter: grayscale(1);
          }
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
      .slid-title {
        box-shadow: 0px 5px 7.5px rgba(0, 0, 0, 0.1);
        border-radius: 15px 15px 0px 0px;
      }
    }
    .discount-mobile-dialog {
      display: unset;
      box-shadow: 0px 5px 7.5px rgba(0, 0, 0, 0.1);
      border-radius: 15px 15px 0px 0px;
      padding-bottom: 60px;
      .discount-slid-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 58px;
        width: 90vw;
        margin: 0 auto;
        line-height: 58px;
        border-bottom: 1px solid  #E0E0E0;
        .discount-item-msg {
          display: flex;
          align-items: center;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          letter-spacing: -0.3px;
          color: #333333;
          .discount-item-price {
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            letter-spacing: -0.3px;
            color: #999999;
            margin-left: 12px;
          }
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
      .slid-title-left {
        width: 24px;
        height: 61px;
        white-space: nowrap;
        overflow: visible;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 65px;
        text-align: right;
        color: $color-yellow;
        cursor: pointer;
      }
    }
  }

}
</style>